// extracted by mini-css-extract-plugin
export default {"tag":"UserTypeTag_tag__Eo16r"};